import { thicknessKey } from "./articleCodes";

/**
 * Trennbrett pricedata codes keyed by panel thickness (matches TrayMaterial in
 * options library). Only a fallback for parts that carry no material of their
 * own — a thickness maps to exactly one article here, so two materials of equal
 * thickness are indistinguishable.
 */
export const TRAY_PANEL_CODES_BY_THICKNESS: Readonly<Record<string, string>> = {
  "6_5": "PLW1417",
  "7": "PLW1417",
  "9": "PLW1419",
  "12": "PLW1412",
  "15": "PLW1415",
  "18": "PLW1418",
  "24": "PLW1424",
  "30": "PLW1430",
};

/** Resolve Trennbrett material code from divider thickness (mm). */
export function getTrayMaterialCodeForStrength(
  strength: number,
): string | undefined {
  return TRAY_PANEL_CODES_BY_THICKNESS[thicknessKey(strength)];
}

/** True when tray panel should use default Trennbrett codes (missing or explicit default color). */
export function isDefaultTrayColor(
  color:
    | { codesByThickness?: Record<string, string>; name?: string }
    | undefined,
): boolean {
  if (!color) {
    return true;
  }
  const name = color.name?.trim().toLowerCase() ?? "";
  if (name.includes("default")) {
    return true;
  }
  const codes = color.codesByThickness;
  if (!codes || Object.keys(codes).length === 0) {
    return false;
  }
  return Object.values(codes).every((code) => code === "DEFAULT");
}
